import React from "react";
import pure from "./higher-order/pure";
import { isActive, getFilterGroups } from "../tournament-filters";

export default pure(function SideFiltersSummary({ list, location, races, tags, tournaments }) {
  var parts = [];
  var tag = tags.valueSeq().find(t => t.get("name") === list);
  var groups = getFilterGroups(tournaments, races, tag);
  for (var i = 0; i < groups.length; i++) {
    var group = groups[i];
    if (!group.filters) {
      continue;
    }

    var summary = group.summary || {};

    var items = [];
    for (var j = 0; j < group.filters.length; j++) {
      var filter = group.filters[j];
      if (isActive(filter, location)) {
        var name = filter.name;
        if (group.key === "game-type") {
          name = name.replace(" Game", "");
        }
        items.push(
          <span className="text--is-bold" key={group.key + "|" + filter.key}>
            {name}
          </span>
        );
      }
    }
    if (i !== 0) {
      var prefix = summary.prefix || "with";
      parts.push(
        <span key={"prefix|" + group.key}>
          {" "}

          {prefix}

          {" "}
        </span>
      );
    }

    var suffix = summary.suffix || group.name;
    if (items.length === 0) {
      parts.push(
        <span className="text--is-bold" key={"all|" + group.key}>
          All
          {suffix}
          s
        </span>
      );
    } else {
      var plural = items.length === 1 && !summary.plural ? "" : "s";
      parts = parts.concat(joinComma(items));
      if (group.key !== "track") {
        parts.push(
          <span className="text--is-bold" key={"suffix|" + group.key}>
            {" "}

            {suffix}

            {plural}
          </span>
        );
      }
    }
  }

  return (
    <span>
      <span>
        Showing
        {" "}
      </span>

      {parts}

      <span>
        .
      </span>
    </span>
  );
});

function joinComma(list) {
  var items = [];
  for (var i = 0; i < list.length - 1; i++) {
    if (i > 0) {
      items.push(
        <span key={"comma|" + list[i].key}>
          ,
          {" "}
        </span>
      );
    }
    items.push(list[i]);
  }
  if (list.length === 2) {
    items.push(
      <span key={"and|" + list[i].key}>
        {" "}
        and

        {" "}
      </span>
    );
  } else if (list.length > 2) {
    items.push(
      <span key={"and|" + list[i].key}>
        , and
        {" "}
      </span>
    );
  }
  items.push(list[i]);
  return items;
}
